import { END_POINTS } from "../helpers";
import { CommonBody, PropertyType } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
};

interface PropertyBody {
  propertyTypeId: string;
  name: string;
  categoryId: string;
  price: number;
  address: string;
  keyFeature: string;
  specifications: string;
  area: string;
  images: string[];
  latitude: number;
  longitude: number;
  propertyConditionId: string;
  amenitiesId: string[];
  beds: string;
  baths: string;
  advertisementPermitNo: string;
  agentId?: string;
}
export const PostPropertyApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<CommonResponseType & { data: any[] }, {}>({
      query: ({ }) => ({
        url: `${END_POINTS.category}?type=subcategory`,
        method: "GET",
      }),
    }),

    getAmenities: builder.query<CommonResponseType & { data: any[] }, {}>({
      query: ({ }) => ({
        url: `${END_POINTS.amenities}`,
        method: "GET",
      }),
    }),
    getPropertyType: builder.query<
      CommonResponseType & { data: PropertyType[] },
      {}
    >({
      query: ({ }) => ({
        url: `${END_POINTS.propertyType}`,
        method: "GET",
      }),
    }),
    getPropertyCondition: builder.query<
      CommonResponseType & { data: any[] },
      void
    >({
      query: () => ({
        url: `${END_POINTS.propertyCondition}`,
        method: "GET",
      }),
    }),
    postProperty: builder.mutation<
      CommonResponseType & { data: any },
      { body: PropertyBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.property}`,
        method: "POST",
        body,
      }),
    }),

    getProperty: builder.query<
      CommonResponseType & { data: any },
      { page: number; limit: number }
    >({
      query: ({ page, limit }) => ({
        url: `${END_POINTS.property}?page=${page + 1}&limit=${limit}`,
        method: "GET",
      }),
    }),

    getClaimedProperties: builder.query<
      CommonResponseType & { data: any },
      { page: number; limit: number, search: string, startDate: string, endDate: string }
    >({
      query: ({ page, limit, search, startDate, endDate }) => ({
        url: `${END_POINTS.claimedTransactions}?page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
      }),
    }),

    getPropertiesWithoutPagination: builder.query<
      CommonResponseType & { data: any },
      {}
    >({
      query: () => ({
        url: `${END_POINTS.propertyListingSorted}`,
        method: "GET",
      }),
    }),

    deleteClaimProperty: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.claimedTransactions}/${id}`,
        method: "DELETE",
      }),
    }),

    temporaryToPublish: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.temporaryToPublish}`,
        method: "PUT",
        body,
      }),
    }),
    publishAll: builder.mutation<
      CommonResponseType & { data: any },
      { companyId: any }
    >({
      query: ({ companyId }) => ({
        url: `${END_POINTS.temporaryToPublish}?companyId=${companyId}`,
        method: "PUT",
      }),
    }),

    getPropertyVerification: builder.query<
      CommonResponseType & { data: any },
      { status: number, page: number, limit: number, startDate: string, endDate: string, search: string }
    >({
      query: ({ status, page, limit, startDate, endDate, search }) => ({
        url: `${END_POINTS.verification}?verificationRequestStatus=${status}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&search=${search}`,
        method: "GET",
      }),
    }),
    verifyProperty: builder.mutation<
      CommonResponseType & { data: any },
      { id: any, body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateVerification}/${id}`,
        method: "PUT",
        body
      }),
    }),

    verifyMultipleProperty: builder.mutation<
      CommonResponseType & { data: any },
       CommonBody 
    >({
      query: ( body ) => ({
        url: `${END_POINTS.updateVerification}`,
        method: "PUT",
        body
      }),
    }),

  }),
});

export const {
  useLazyGetCategoryQuery,
  usePostPropertyMutation,
  useLazyGetPropertyQuery,
  useLazyGetAmenitiesQuery,
  useLazyGetPropertyConditionQuery,
  useLazyGetClaimedPropertiesQuery,
  useLazyGetPropertiesWithoutPaginationQuery,
  useLazyDeleteClaimPropertyQuery,
  useTemporaryToPublishMutation,
  usePublishAllMutation,
  useLazyGetPropertyVerificationQuery,
  useVerifyPropertyMutation,
  useVerifyMultiplePropertyMutation
} = PostPropertyApi;
